import { IdentityTypeDirectors, OnboardingDocument } from 'src/features/common';

export type DocumentWithOptionalBody = OnboardingDocument & {
  documentBody?: string;
  documentUrl?: string;
  initial?: boolean;
  unconfirmed?: boolean;
};

export type IdItem = {
  idType: IdentityTypeDirectors;
  idNumber: string;
};

export type UploadError = {
  error: boolean;
  message: string;
};

export type UploadDocumentError = {
  identityDocument: UploadError;
  workPermit: UploadError;
  permanentRes: UploadError;
  proofOfBanking: UploadError;
  resLetter: UploadError;
  refugeeLetter: UploadError;
  asylumSeeker: UploadError;
  npoFoundingDoc: UploadError;
  trustResLetter: UploadError;
  trustDeed: UploadError;
};

export enum OnboardingDocumentTypeEnum {
  ID_TYPE = 'ID',
  BANK_PROOF = 'Proof of bank account letter',
  RES_LETTER = 'Resolution letter',
  NPO_FOUNDING_DOC = 'NPO founding documentation',
  TRUST_DEED = 'Trust deed',
  TRUST_RES_LETTER = 'Resolution letter',
  PROOF_OF_RESIDENCE = 'Proof of residence',
  ID_BOOK = 'Old Green Identity Document',
  ID_CARD = 'New Identity Card',
  PASSPORT = 'Passport',
  WORK_PERMIT = 'Work Permit',
  PERMANENT_RESIDENCY = 'Permanent Residency',
  FOREIGN_NATIONAL_ID_DOC = 'Foreign National ID Document',
  REFUGEE_LETTER = 'Refugee Letter',
  ASYLUM_SEEKER = 'Asylum Seeker',
}

export type IDDocsUploaded = {
  idNumber: string;
  numOfSmartCards: number;
  numOfGreenBooks: number;
  numOfPassports: number;
};
